<template>
  
    <div class="left_menu_wrapper" v-if="leftMenuVisible && winW >1024">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
        <div class="veil" @click="hideLeftMenu"></div>
      </transition>
      <div class="menu left_menu animated slideInUp">
        <div class="container">
          <div class="menu_close">
            <img src="../../assets/img/icons/menu_close.png" alt="close" @click="hideLeftMenu">
          </div>
          <ul class="langs">
            <li data-lang="ru" :class="{'active': $i18n.locale === 'ru'}">
              <a href="javascript:;" hreflang="ru" target="_top" @click="setLang('ru')">ru</a>
            </li>
            <li data-lang="ua" :class="{'active': $i18n.locale === 'ua'}">
              <a href="javascript:;" hreflang="uk" target="_top" @click="setLang('ua')">ua</a>
            </li>
          </ul>
          <div class="menu_logo">
            <img src="../../assets/img/logo_menu.svg" style="width:220px" alt="Multiplex">
          </div>
          <div class="mob_container">
            <div class="menu_list">
              <a href="https://multiplex.ua" class="menu_item">{{ $t("pop_ups.left_menu.now_in_cinema") }}</a>
              <a href="https://multiplex.ua/soon" class="menu_item">{{ $t("pop_ups.left_menu.soon") }}</a>
              <a href="https://multiplex.ua/promotions" class="menu_item">{{ $t("pop_ups.left_menu.promos") }}</a>
              <a href="https://multiplex.ua/cinemas" class="menu_item">{{ $t("pop_ups.left_menu.cinemas") }}</a>
              <a href="https://multiplex.ua/faq" class="menu_item">{{ $t("pop_ups.left_menu.faq") }}</a>
              <a href="https://multiplex.ua/about" class="menu_item">{{ $t("pop_ups.left_menu.about") }}</a>
              <a href="javascript:;" class="menu_item active">{{ $t("pop_ups.left_menu.personal") }}</a>
            </div>
          </div>
          <div class="menu_phone">0 800 505 333</div>
          <div class="menu_soc">
            <a href="http://www.facebook.com/uamultiplex" target="_blank" class="menu_soc_item">Facebook</a>
            <a href="https://www.youtube.com/user/MultiplexChannel" target="_blank" class="menu_soc_item">Youtube</a>
            <a href="https://www.instagram.com/uamultiplex/" target="_blank" class="menu_soc_item">Instagram</a>
          </div>
        </div>
      </div>
    </div>
  
</template>
<script>
import Store from '../../store'
export default {
  computed: {
    leftMenuVisible: function () {
      return Store.state.leftMenuVisible
    },
    winW: function () {
      return Store.state.winW
    }
  },
  methods: {
    hideLeftMenu: function () {
      Store.commit('hideLeftMenu')
    },
    setLang: function (lang) {
      Store.commit('setLang', lang)
      this.$i18n.locale = lang
      this.$cookie.set('uLang', lang, {expires: 365, domain: '.multiplex.ua'})
      this.hideLeftMenu()
      document.title = this.$t('commons.title')
    }
  }
}
</script>



// WEBPACK FOOTER //
// left-menu.vue?7c70d38e